import Invoices from "./Invoices";
export default function Estimates() {
    return <Invoices docType="estimate" title="Estimates & Quotations" kicker="SALES" subtitle="Pre-sales quotations, ready to convert to invoices." newPath="/sales/invoices/new" />;
}
